/**
 * Utility functions for formatting values
 */

/**
 * Format a number as currency (AED)
 * @param value - The value to format
 * @returns Formatted string 
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-AE', { 
    style: 'currency', 
    currency: 'AED' 
  }).format(value);
};

/**
 * Format a decimal as percentage
 * @param value - The value to format (e.g. 0.05 for 5%)
 * @returns Formatted string with % sign
 */
export const formatPercentage = (value: number): string => {
  return `${(value * 100).toFixed(1)}%`;
};

/**
 * Format a number with specific precision
 * @param value - The value to format
 * @param digits - Number of decimal places
 * @returns Formatted string
 */
export const formatNumber = (value: number, digits: number = 2): string => {
  return value.toFixed(digits);
};

/**
 * Format a value in thousands (K)
 * @param value - The value to format
 * @returns Formatted string with K suffix
 */
export const formatThousands = (value: number): string => {
  return `${(value / 1000).toFixed(1)}K`;
};

/**
 * Format a value in millions (M)
 * @param value - The value to format
 * @returns Formatted string with M suffix
 */
export const formatMillions = (value: number): string => {
  return `${(value / 1000000).toFixed(2)}M`;
};